import localForage from 'localforage';
var LocalStorageService = (function () {
    function LocalStorageService() {
    }
    LocalStorageService.prototype.setValue = function (key, value) {
        return localForage.setItem(key, JSON.stringify(value));
    };
    LocalStorageService.prototype.getValue = function (key) {
        return localForage.getItem(key);
    };
    LocalStorageService.prototype.remove = function (key) {
        return localForage.removeItem(key);
    };
    return LocalStorageService;
}());
export { LocalStorageService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/service/local-storage.service.ts.pre-build-optimizer.js